import { createActions } from "reduxsauce";

const { Types, Creators } = createActions({
  consultarPaciente: ["payload"],
  consultarPacienteLoading: null,
  consultarPacienteSuccess: ["consultarPacienteData"],
  consultarPacienteFailure: ["consultarPacienteError"],

  consultarPacientes: ["payload"],
  consultarPacientesLoading: null,
  consultarPacientesSuccess: ["consultarPacientesData"],
  consultarPacientesFailure: ["consultarPacientesError"],

  validarHojaQuirurgica: ["payload"],
  validarHojaQuirurgicaLoading: null,
  validarHojaQuirurgicaSuccess: ["validarHojaQuirurgicaData"],
  validarHojaQuirurgicaFailure: ["validarHojaQuirurgicaError"],

  consultarEstatusHojasQX: ["payload"],
  consultarEstatusHojasQXLoading: null,
  consultarEstatusHojasQXSuccess: ["consultarEstatusHojasQXData"],
  consultarEstatusHojasQXFailure: ["consultarEstatusHojasQXError"],

  registrarCobertura: ["payload"],
  registrarCoberturaLoading: null,
  registrarCoberturaSuccess: ["registrarCoberturaData"],
  registrarCoberturaFailure: ["registrarCoberturaError"],

  consultarDetalleAnexos: ["payload"],
  consultarDetalleAnexosLoading: null,
  consultarDetalleAnexosSuccess: ["consultarDetalleAnexosData"],
  consultarDetalleAnexosFailure: ["consultarDetalleAnexosError"],

  consultarDetalleCobertura: ["payload"],
  consultarDetalleCoberturaLoading: null,
  consultarDetalleCoberturaSuccess: ["consultarDetalleCoberturaData"],
  consultarDetalleCoberturaFailure: ["consultarDetalleCoberturaError"],
});

export { Types };

export default Creators;
